// زرّ «رجوع» في موبايل أندرويد (المراجعة الشاملة الثالثة، والمالك 03/10/2026: «حل الموضوع»). كان يُخرج من التطبيق كلّه بدل أن
// يرجع للتاب أو الشاشة السابقة — فالتطبيق يتنقّل بعنوان الصفحة (#التاب، والمحادثة على الموبايل pushState)، وأندرويد لا يعرف ذلك.
// الآن: رجوعٌ في تاريخ الصفحة ما دام فيه ما يُرجَع إليه، وإلّا يُصغَّر التطبيق إلى الخلفية (كالواتساب) لا يُقفل —
// فيبقى داخلًا ويصله الإشعار. وفي المتصفّح لا شيء هنا، وتطبيقٌ قديم بلا الإضافة يُتجاوز بصمت.
import { Capacitor } from '@capacitor/core';
import { isNativeApp } from './platform.ts';

let installed = false;

export async function installBackButton(): Promise<void> {
  if (installed || !isNativeApp() || !Capacitor.isPluginAvailable('App')) return;
  installed = true;
  const { App } = await import('@capacitor/app');
  await App.addListener('backButton', ({ canGoBack }) => {
    if (canGoBack || window.history.length > 1) window.history.back();
    else void App.minimizeApp();
  });
}
